<script>
import {getEntranceSetting, setSystemSettingInfo} from "@/api/setting-api";

export default {
  name: "SystemInfoPage",
  data() {
    return {
      activeName: "first",

      form0: {
        enter: '',
        checkout: '',
        count: ''
      },
      rules0: {
        enter: [
          {required: true, message: '请选择进入限制', trigger: 'change'},
        ],
        checkout: [
          {required: true, message: '请选择签离限制', trigger: 'change'},
        ],
        count: [
          {required: true, message: '请选择次数限制', trigger: 'change'},
        ],
      },
      form1: {
        radio: ''
      },

    }
  },
  mounted() {
    getEntranceSetting().then(({data}) => {
      console.log("getEntranceSetting", data)
      if (data.code === 200) {
        data.data.forEach(item => {
          if (item.type === "USUAL_RULE") {
            this.form1.radio = item.content
          } else if (item.type === "GENERAL_RULE") {
            let content = JSON.parse(item.content)
            if (content) {
              this.form0.enter = content.enter
              this.form0.checkout = content.checkout
              this.form0.count = content.count
            }
          }
        })

      } else {
        this.showServerErrMsg(data)
      }
    }).catch((err) => {
      this.showNetErrMsg(err)
    })

  },

  methods: {
    onCommend() {
      console.log("onCommend", this.form1.radio)  // CHECK PASS
      this.$refs.form1.validate((valid) => {
        if (valid) {
          const postData = {
            "target": "DOORGUARD", "type": "USUAL_RULE", "content": this.form1.radio, "state": "VALID"
          }
          setSystemSettingInfo(postData).then(({data}) => {
            if (data.code === 200) {
              this.$message.success("保存成功")
            } else {
              this.showServerErrMsg(data)
            }
          }).catch((err) => {
            this.showNetErrMsg(err)
          })
        }
      });
    },
    onForm0Commend() {
      console.log("onForm0Commend", this.form0)  // CHECK PASS
      this.$refs.form0.validate((valid) => {
        if (valid) {
          let content = {
            enter: this.form0.enter,
            checkout: this.form0.checkout,
            count: this.form0.count
          }
          const postData = {
            "target": "DOORGUARD", "type": "GENERAL_RULE", "content": JSON.stringify(content), "state": "VALID"
          }
          setSystemSettingInfo(postData).then(({data}) => {
            if (data.code === 200) {
              this.$message.success("保存成功")
            } else {
              this.showServerErrMsg(data)
            }
          }).catch((err) => {
            this.showNetErrMsg(err)
          })
        }
      });
    },
  }
}
</script>

<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="通用设置" name="first">
        <el-form :model="form0" ref="form0" :rules="rules0" label-width="100px" label-position="left">
          <el-form-item label="门禁规则" required prop="enter">
            <el-radio v-model="form0.enter" label="CHECK" border size="small">先签到，然后通行</el-radio>
            <el-radio v-model="form0.enter" label="PASS" border size="small">审批通过，直接通行</el-radio>
          </el-form-item>
          <el-form-item label="签离限制" required prop="checkout">
            <el-radio v-model="form0.checkout" label="SPLIT" border size="small">访客机单独签离</el-radio>
            <el-radio v-model="form0.checkout" label="MERGE" border size="small">离开自动签离</el-radio>
          </el-form-item>
          <el-form-item label="次数限制" required prop="count">
            <el-radio v-model="form0.count" label="MoreAndMore" border size="small">多进多出</el-radio>
            <el-radio v-model="form0.count" label="MoreAndOne" border size="small">多进一出</el-radio>
            <el-radio v-model="form0.count" label="OneAndOne" border size="small">一进一出</el-radio>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 100px" @click="onForm0Commend">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="常访设置" name="second">
        <el-form :model="form1" ref="form1" label-width="100px" label-position="left">
          <el-form-item label="门禁规则" required>
            <el-radio v-model="form1.radio" label="CHECK" border size="small">先签到，然后通行</el-radio>
            <el-radio v-model="form1.radio" label="PASS" border size="small">无需签到，直接通行</el-radio>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 100px" @click="onCommend">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<style scoped lang="less">

</style>
